export default "__VITE_ASSET__CcLSMhux__"